import React from 'react';
import Handle from './Handler';
import NodeWrapper, {Title} from './NodeWrapper';

const CustomInput = (props) => {
  return (
    <NodeWrapper {...props}>
      <Handle type="target" position="left" />
      <div>
        <Title title={props.data.label} />
      </div>

      {/* <Handle type="source" position="bottom" /> */}
    </NodeWrapper>
  );
};

export default CustomInput;
